import {
  GET_ADMIN_APP_TRACK_BY_COMP_LIST_FAIL,
  GET_ADMIN_APP_TRACK_BY_COMP_LIST_REQUEST,
  GET_ADMIN_APP_TRACK_BY_COMP_LIST_SUCCESS,
} from "../../types/admin/appTrackTypes";

export const getCompAppTrackByDateReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ADMIN_APP_TRACK_BY_COMP_LIST_REQUEST:
      return {
        ...state,
        compAppLoading: true,
      };
    case GET_ADMIN_APP_TRACK_BY_COMP_LIST_SUCCESS:
      return {
        ...state,
        compAppLoading: false,
        compAppInfo: payload,
        compAppError: "",
      };
    case GET_ADMIN_APP_TRACK_BY_COMP_LIST_FAIL:
      return {
        ...state,
        compAppLoading: false,
        compAppError: payload,
        compAppInfo: {},
      };
    default:
      return state;
  }
};
